import script from "./ChatPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatPanel.vue?vue&type=script&setup=true&lang=js"

import "./ChatPanel.vue?vue&type=style&index=0&id=109c447e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_webpack@5.106.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-109c447e"]])

export default __exports__